import { render, staticRenderFns } from "./ChallengesReport.vue?vue&type=template&id=bc7aef64&scoped=true&"
import script from "./ChallengesReport.vue?vue&type=script&lang=js&"
export * from "./ChallengesReport.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesReport.vue?vue&type=style&index=0&id=bc7aef64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7aef64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7aef64')) {
      api.createRecord('bc7aef64', component.options)
    } else {
      api.reload('bc7aef64', component.options)
    }
    module.hot.accept("./ChallengesReport.vue?vue&type=template&id=bc7aef64&scoped=true&", function () {
      api.rerender('bc7aef64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/ChallengesReport.vue"
export default component.exports